module.exports = __webpack_public_path__ + "img/clevermadeeasy-img.8fbf9afa.jpg";